import React, { useEffect, useState } from "react";
import "./ModalProduct.css";

const ModalProductDetails = ({ isVisible, onClose, productId }) => {
  const [show, setShow] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const [productDetails, setProductDetails] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [selectedPricingType, setSelectedPricingType] =
    useState("dailyPricing");
  const [selectedPricingOption, setSelectedPricingOption] = useState("");
  const [selectedPricingValue, setSelectedPricingValue] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedHour, setSelectedHour] = useState("12");
  const [selectedMinute, setSelectedMinute] = useState("00");
  const [selectedPeriod, setSelectedPeriod] = useState("AM");

  const [isOpen, setIsOpen] = useState(false);

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  const [isOpenDetails, setIsOpenDetails] = useState(false);

  const toggleCollapseDetails = () => {
    setIsOpenDetails(!isOpenDetails);
  };

  const allImages =
    productDetails && productDetails.singleImage
      ? [productDetails.singleImage, ...(productDetails.images || [])]
      : [];

  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const handleAddToCart = () => {
    if (productDetails) {
      // Combine date and time selections into a Date object
      const [year, month, day] = selectedDate.split("-");
      let hour = parseInt(selectedHour, 10);
      const minute = parseInt(selectedMinute, 10);

      // Adjust hour based on AM/PM
      if (selectedPeriod === "PM" && hour < 12) hour += 12;
      if (selectedPeriod === "AM" && hour === 12) hour = 0;

      // Create a JavaScript Date object
      const combinedDate = new Date(
        Date.UTC(year, month - 1, day, hour, minute)
      );

      const cartItem = {
        ...productDetails,
        quantity,
        // selectedPricingType,
        // selectedPricingOption,
        // selectedPricingValue,
        selectedDate: combinedDate, // Store as a Date object
      };

      let cart = JSON.parse(localStorage.getItem("cart")) || [];
      cart.push(cartItem);
      localStorage.setItem("cart", JSON.stringify(cart));

      alert("Product added to cart with quantity: " + quantity);
    }
  };

  const incrementQuantity = () => setQuantity(quantity + 1);
  const decrementQuantity = () => setQuantity(Math.max(1, quantity - 1));

  // const handlePricingTypeChange = (e) => {
  //   setSelectedPricingType(e.target.value);
  //   setSelectedPricingOption(""); // Reset pricing option when pricing type changes
  // };

  // const handlePricingOptionChange = (e) => {
  //   setSelectedPricingOption(e.target.value);
  // };

  // Calculate selected pricing value dynamically
  // useEffect(() => {
  //   if (
  //     productDetails &&
  //     selectedPricingType &&
  //     selectedPricingOption &&
  //     productDetails[selectedPricingType]
  //   ) {
  //     const pricing = productDetails[selectedPricingType].find(
  //       (pricing) => pricing.hasOwnProperty(selectedPricingOption)
  //     );
  //     if (pricing) {
  //       setSelectedPricingValue(pricing[selectedPricingOption]);
  //     } else {
  //       setSelectedPricingValue("");
  //     }
  //   }
  // }, [productDetails, selectedPricingType, selectedPricingOption]);

  useEffect(() => {
    if (isVisible) {
      setIsMounted(true);
      setTimeout(() => setShow(true), 10);

      if (productId) {
        fetch(`https://server-gs.vercel.app/web/event-products-details/${productId}`)
          .then((res) => res.json())
          .then((data) => setProductDetails(data))
          .catch((error) =>
            console.error("Failed to load product details:", error)
          );
      }
    } else {
      setShow(false);
      setTimeout(() => setIsMounted(false), 300);
    }
  }, [isVisible, productId]);

  if (!isMounted) return null;

  return (
    <div
      className={`fixed inset-0 flex justify-center items-center z-50 modal-overlay ${
        show ? "show" : ""
      }`}
    >
      <div className="bg-white rounded-lg shadow-custom-full w-[1000px] mx-5 sm:mx-auto">
        <div className="flex justify-between py-3 px-5 items-center border-b shadow-md">
          <h1 className="text-rose-900 font-raleway">Details</h1>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full flex justify-center items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8 text-rose-900"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="bg-green p-5 h-[750px] overflow-y-auto shadow-lg">
          {productDetails ? (
            <div>
              <div className="flex flex-row gap-4">
                <div className="w-[40%]">
                  {allImages[activeTab] && (
                    <img
                      src={allImages[activeTab]}
                      alt={`${activeTab + 1}`}
                      className="w-[400px] h-[400px] object-cover rounded-md"
                    />
                  )}
                  <div className="grid grid-cols-3 gap-5 mt-2">
                    {allImages.map((image, index) => (
                      <button
                        key={index}
                        onClick={() => handleTabClick(index)}
                        className="relative"
                      >
                        <img
                          src={image}
                          alt={`Thumbnail ${index + 1}`}
                          className={`w-28 h-28 object-cover ${
                            index === activeTab ? "bg-rose-100 p-2" : ""
                          }`}
                        />
                      </button>
                    ))}
                  </div>
                </div>
                <div className="w-[60%]">
                  <h1 className="font-raleway text-4xl">
                    {productDetails.title}
                  </h1>

                  <div>
                    <h1 className="text-3xl font-roboto text-rose-900 font-semibold my-6">
                      One day pricing : {productDetails.perDayPricing} $
                    </h1>
                  </div>
                  <div className="flex flex-col gap-2 ">
                    <form class="my-6">
                      <label
                        for="quantity-input"
                        className="block font-roboto text-rose-900 text-lg mb-2"
                      >
                        Choose quantity:
                      </label>
                      <div class="relative flex items-center max-w-[12rem]">
                        <button
                          onClick={decrementQuantity}
                          type="button"
                          id="decrement-button"
                          data-input-counter-decrement="quantity-input"
                          class="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-10 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none"
                        >
                          <svg
                            class="w-4 h-4 text-gray-900 dark:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 18 2"
                          >
                            <path
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M1 1h16"
                            />
                          </svg>
                        </button>
                        <span class="bg-gray-50 flex justify-center items-center border-x-0 border-gray-300 h-10 text-center text-gray-900 text-2xl  font-roboto focus:ring-blue-500 focus:border-blue-500  w-full py-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                          {quantity}
                        </span>

                        {/* <input type="text" id="quantity-input" data-input-counter aria-describedby="helper-text-explanation" class="bg-gray-50 border-x-0 border-gray-300 h-14 text-center text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full py-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="999" required /> */}
                        <button
                          onClick={incrementQuantity}
                          type="button"
                          id="increment-button"
                          data-input-counter-increment="quantity-input"
                          class="bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:border-gray-600 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-10 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none"
                        >
                          <svg
                            class="w-4 h-4 text-gray-900 dark:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 18 18"
                          >
                            <path
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M9 1v16M1 9h16"
                            />
                          </svg>
                        </button>
                      </div>
                    </form>
                    <div>
                      <label
                        for="quantity-input"
                        className="block font-roboto text-rose-900 text-xl font-semibold mb-2"
                      >
                        Total price:{" "}
                        {quantity && productDetails?.perDayPricing
                          ? quantity * productDetails.perDayPricing
                          : "Invalid input"}{" "}
                        $
                      </label>
                    </div>
                  </div>
                  {/* 
                  <div className="flex items-center gap-3 mt-5">
                    <button
                      onClick={decrementQuantity}
                      className="px-3 py-1 bg-gray-300 rounded-md"
                    >
                      -
                    </button>
                    <span>{quantity}</span>
                    <button
                      onClick={incrementQuantity}
                      className="px-3 py-1 bg-gray-300 rounded-md"
                    >
                      +
                    </button>
                  </div> */}
                  {/* <label className="block font-roboto text-rose-900 text-lg mt-2">
                    Select Pricing:
                  </label>

                  <div className="flex flex-row gap-4">
                    <select
                      value={selectedPricingType}
                      onChange={handlePricingTypeChange}
                      className="mt-1 rounded-lg border border-rose-600 focus:border-rose-600 active:border-rose-600 font-roboto"
                    >
                      <option value="">Select Pricing Type</option>
                      {productDetails.dailyPricing && (
                        <option value="dailyPricing">Daily Pricing</option>
                      )}
                      {productDetails.hourlyPricing && (
                        <option value="hourlyPricing">Hourly Pricing</option>
                      )}
                    </select>
                    {selectedPricingType && (
                      <select
                        value={selectedPricingOption}
                        onChange={(e) =>
                          setSelectedPricingOption(e.target.value)
                        }
                        className="mt-1 ml-4 rounded-lg border border-rose-600 focus:border-rose-600 active:border-rose-600 font-roboto"
                      >
                        <option value="">Select Pricing Option</option>
                        {productDetails[selectedPricingType].map(
                          (pricing, index) =>
                            Object.entries(pricing).map(
                              ([key, value]) =>
                                value !== "0" && (
                                  <option key={key} value={key}>
                                    {key} - ${value}
                                  </option>
                                )
                            )
                        )}
                      </select>
                    )}
                  </div> */}

                  {/* <div className="flex flex-row gap-4">
             
                    <div className="mt-4">
                      <label className="block font-roboto text-rose-900 text-lg mb-1">
                        Select Date:
                      </label>
                      <input
                        type="date"
                        value={productDetails.selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        className="border border-rose-600 focus:border-rose-600 active:border-rose-600 rounded px-2 py-1"
                      />
                    </div>

                    <div className="mt-4">
                      <label className="block font-roboto text-rose-900 text-lg mb-1">
                        Select Time:
                      </label>
                      <div className="flex gap-2">
                        <select
                          value={selectedHour}
                          onChange={(e) => setSelectedHour(e.target.value)}
                          className="border border-rose-600 focus:border-rose-600 active:border-rose-600 rounded px-2 py-1"
                        >
                          {Array.from({ length: 12 }, (_, i) => i + 1).map(
                            (hour) => (
                              <option
                                key={hour}
                                value={hour < 10 ? `0${hour}` : hour}
                              >
                                {hour < 10 ? `0${hour}` : hour}
                              </option>
                            )
                          )}
                        </select>
                        <span>:</span>
                        <select
                          value={selectedMinute}
                          onChange={(e) => setSelectedMinute(e.target.value)}
                          className="border border-rose-600 focus:border-rose-600 active:border-rose-600 rounded px-2 py-1"
                        >
                          {Array.from({ length: 12 }, (_, i) => i * 5).map(
                            (minute) => (
                              <option
                                key={minute}
                                value={minute < 10 ? `0${minute}` : minute}
                              >
                                {minute < 10 ? `0${minute}` : minute}
                              </option>
                            )
                          )}
                        </select>
                        <select
                          value={selectedPeriod}
                          onChange={(e) => setSelectedPeriod(e.target.value)}
                          className="border border-rose-600 focus:border-rose-600 active:border-rose-600 rounded px-2 py-1"
                        >
                          <option value="AM">AM</option>
                          <option value="PM">PM</option>
                        </select>
                      </div>
                    </div>
                  </div> */}

                  <button
                    onClick={handleAddToCart}
                    className="mt-5 font-roboto text-xl w-full py-2 bg-rose-700 hover:bg-rose-900 duration-300 ease-in-out text-white rounded-md"
                  >
                    Add to Quote Request
                  </button>
                  <div className=" my-4">
                    <button
                      onClick={toggleCollapse}
                      className="w-full text-left flex items-center justify-between font-roboto text-rose-900  text-lg border-b border-rose-400 py-2 focus:outline-none "
                    >
                      <span>Description</span>
                      <span className="transform transition-transform duration-300">
                        {isOpen ? "▲" : "▼"}
                      </span>
                    </button>
                    <div
                      className={`overflow-auto transition-[max-height] duration-500 ease-in-out ${
                        isOpen ? "max-h-40" : "max-h-0"
                      }`}
                    >
                      <div className="mt-1 p-2 rounded-md">
                        <h1 className="text-sm font-roboto">
                          {productDetails.productDescription
                            ? productDetails.productDescription
                            : "No description"}
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className=" my-4">
                    <button
                      onClick={toggleCollapseDetails}
                      className="w-full text-left flex items-center justify-between font-roboto text-rose-900  text-lg border-b border-rose-400 py-2 focus:outline-none "
                    >
                      <span>Details</span>
                      <span className="transform transition-transform duration-300">
                        {isOpenDetails ? "▲" : "▼"}
                      </span>
                    </button>
                    <div
                      className={`overflow-auto transition-[max-height] duration-500 ease-in-out ${
                        isOpenDetails ? "max-h-40" : "max-h-0"
                      }`}
                    >
                      <div className="mt-1 p-2 rounded-md">
                        <h1 className="text-sm font-roboto">
                          Height:
                          {productDetails.height
                            ? productDetails.height
                            : "No description"}
                        </h1>
                        <h1 className="text-sm font-roboto">
                          Length:
                          {productDetails.length
                            ? productDetails.length
                            : "No description"}
                        </h1>
                        <h1 className="text-sm font-roboto">
                          Width:
                          {productDetails.width
                            ? productDetails.width
                            : "No description"}
                        </h1>
                        <h1 className="text-sm font-roboto">
                          Shape:
                          {productDetails.shape
                            ? productDetails.shape
                            : "No description"}
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p>Loading...</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalProductDetails;
